import { useState } from 'react'
import { supabase } from '../supabase'
import { T } from '../styles/theme'

export default function CambiarPassword() {
  const [form, setForm] = useState({ nueva: '', confirmar: '' })
  const [loading, setLoading] = useState(false)
  const [msg, setMsg] = useState(null)
  const [error, setError] = useState(null)

  async function handleCambiar() {
    setMsg(null)
    setError(null)
    if (!form.nueva) { setError('Introduce una contraseña'); return }
    if (form.nueva.length < 6) { setError('Mínimo 6 caracteres'); return }
    if (form.nueva !== form.confirmar) { setError('Las contraseñas no coinciden'); return }
    setLoading(true)
    const { error } = await supabase.auth.updateUser({ password: form.nueva })
    if (error) setError(error.message)
    else { setMsg('Contraseña actualizada correctamente'); setForm({ nueva: '', confirmar: '' }) }
    setLoading(false)
  }

  const inp = (label, key, placeholder) => (
    <div style={{ marginBottom: 12 }}>
      <div style={{ fontSize: 13, color: T.muted, marginBottom: 6 }}>{label}</div>
      <input
        type="password"
        placeholder={placeholder}
        value={form[key]}
        onChange={e => setForm(f => ({ ...f, [key]: e.target.value }))}
        style={{ width: '100%', background: T.bg, border: `1px solid ${T.cardB}`, borderRadius: 12, padding: '12px 16px', fontSize: 15, fontFamily: 'DM Sans', outline: 'none', color: T.text }}
      />
    </div>
  )

  return (
    <div>
      {inp('Nueva contraseña', 'nueva', 'Mínimo 6 caracteres')}
      {inp('Confirmar contraseña', 'confirmar', 'Repite la contraseña')}
      {error && (
        <div style={{ background: 'rgba(248,113,113,0.12)', border: `1px solid ${T.danger}`, borderRadius: 10, padding: '10px 14px', fontSize: 13, color: T.danger, marginBottom: 12 }}>
          {error}
        </div>
      )}
      {msg && (
        <div style={{ background: T.accentSoft, border: `1px solid ${T.accent}`, borderRadius: 10, padding: '10px 14px', fontSize: 13, color: T.accent, marginBottom: 12 }}>
          ✅ {msg}
        </div>
      )}
      <button onClick={handleCambiar} disabled={loading} style={{
        width: '100%', padding: 12, borderRadius: 12,
        background: loading ? T.cardB : T.accent,
        color: loading ? T.muted : '#000',
        fontSize: 14, fontWeight: 700, border: 'none',
        cursor: loading ? 'not-allowed' : 'pointer',
        marginBottom: 4
      }}>
        {loading ? 'Guardando...' : 'Actualizar contraseña'}
      </button>
    </div>
  )
}